import { createSelector } from "@ngrx/store";
import * as fromClassroom from "./lesson.selectors";

// --- Yjs-synced: read from ClassroomState ---

export const selectBasicSlideList = createSelector(
    fromClassroom.selectLessonState,
    (state) => state.navigationPreviewBasicSlideList
);

export const selectHasParentLectionOrChapter = createSelector(
    fromClassroom.selectLessonState,
    (state) => state.navigationPreviewHasParent
);

export const selectCurrentBasicSlideIdx = createSelector(
    fromClassroom.selectLessonState,
    (state) => state.navigationPreviewNextSlideData?.basicSlideIdx
);

export const selectNavigationPreviewNextSlideData = createSelector(
    fromClassroom.selectLessonState,
    (state) => state.navigationPreviewNextSlideData
);

const selectExtensionSlideList = createSelector(
    fromClassroom.selectLessonState,
    (state) => state.navigationPreviewNextSlideData?.extensionSlides
);

const selectExtensionSlideIdx = createSelector(
    fromClassroom.selectLessonState,
    (state) => state.navigationPreviewNextSlideData?.extensionSlideIdx
);

export const selectAssignedDriverscamVimeoVideoId = createSelector(
    fromClassroom.selectLessonState,
    (state) => state.navigationPreviewNextSlideData?.assignedDriverscamVideo
);

const selectExtensionSlideCount = createSelector(
    selectExtensionSlideList,
    (slides) => (slides ? slides.length : undefined)
);

export const selectExtensionSlides = createSelector(
    selectExtensionSlideList,
    selectExtensionSlideIdx,
    selectExtensionSlideCount,
    (slides, idx, cnt) => ({
        slides,
        idx,
        cnt,
    })
);

// selectDifficultQuestionNumbers migrated to `ActiveElementUiStateService.difficultQuestionNumbers`
// (Signal derived directly from `ClassroomFacade.currentLayerSlide`).
